/**
 * Created by dushyantha on 9/15/16.
 */
(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name crewProfile.directive:crewProfileSearch
     * @restrict EA
     * @element
     *
     */
    angular
        .module('crewProfile')
        .directive('crewProfileSearch', crewProfileSearch)
	    .directive('focusOn',function($timeout) {
			return {
				restrict : 'A',
				link : function(vm,$element,$attr) {
					vm.$watch($attr.focusOn,function(_focusVal) {
						$timeout(function() {
							_focusVal ? $element[0].focus() :
								$element[0].blur();
	                	});
	            	});
	        	}
			}
		});

    function crewProfileSearch(MessageService, $stateParams) {
        return {
            restrict: 'EA',
            scope: {
                openSearchPanel:'&',
                onChangeCrewType:'&',
                onSearchCrew:'&',
                crewTypes: '=',
                crewList: '=',
                showSearchArea :'=',
                crewDetails : '='
            },
            templateUrl: 'profile/directives/crew-profile-search-derective.tpl.html',
            replace: false,
            controllerAs: 'crewProfileSearch',
            bindToController: true,

            controller: ['$scope', function ($scope) {
                var vm = this;
                vm.model ={
                    crewID :'',
                    crewDetails:'',
                    crewType:''
                };

                vm.showSearchArea = false;

                vm.displaySearchArea = function () {
                    vm.showSearchArea = !vm.showSearchArea;
                    vm.openSearchPanel();
                };

                if($stateParams.crewId == ""){
                	vm.displaySearchArea();
                }


                vm.loadCrewList = function(){
                    vm.model.crewID = '';
                    vm.model.crewDetails ='';
                    vm.onChangeCrewType({crewType :vm.model.crewType.crewTypeCode,isActive :'all'});
                };

                vm.loadCrewID = function(){
                    vm.model.crewID = vm.model.crewDetails.crewId;
                };

                vm.onSearchClick = function () {
                    if(!!vm.model.crewID){
                        vm.onSearchCrew({'searchParam': vm.model.crewID});
                    }
                    else{
                        MessageService.warning(MessageService.MESSAGES.CREW_PROFILE.ERROR_SEARCH);
                    }
                };

                vm.onCrewIdChange = function () {
                    vm.model.crewType  = {crewTypeCode:''};
                    vm.model.crewDetails ='';
                };

                $scope.$watch('crewProfileSearch.crewDetails', function (newVal,oldVal) {
                    if(!!newVal && (newVal != oldVal)){
                        vm.model.crewType  = _.find(vm.crewTypes,{crewTypeCode : newVal.crewTypeCode}) || {crewTypeCode:''}
                        vm.model.crewDetails = (newVal.firstName + ' ' + newVal.lastName)  || '';
                        vm.model.crewID = newVal.crewId || '';
                    }
                });

            }],
            link: function (scope, element, attrs) {

            }
        };
    }
}());


